import React from 'react'

export const MaterialIcon = ({ Icon, iconColor }) => (
    <Icon style={{ fill: iconColor }} />
)
